
import Vue from "vue";

export default Vue.extend({
  name: "Task",
  props: {
    todo: {
      type: Object,
    },
    icon: {
      type: String,
    },
  },
});
